export default __webpack_public_path__ + "static/media/pmtire.8d53b308.png";